<template>
  <Record :title="article.topic">
    <Row>
      <Column :xs="4">
        <Set icon="clock" :label="$t('date')">
          {{ $d(article.createdAt, 'short') }}
        </Set>
      </Column>
      <Column :xs="4">
        <Set icon="site" :label="$t('site')">
          {{ siteName | fallback }}
        </Set>
      </Column>
      <Column :xs="4">
        <Set icon="user" :label="$t('author')">
          {{ articleAuthor | fallback }}
        </Set>
      </Column>
    </Row>
    <RecordActions
      slot="actions"
      :doShowDelete="hasRole('>=MODERATOR')"
      name="article"
      :record="article"
      routeName="Article">
      <Tag
        v-if="status"
        slot="tail"
        :class="status.theme">
        {{ status.label }}
      </Tag>
    </RecordActions>
  </Record>
</template>

<script>
import Record from '@components/Record'
import RecordActions from '@components/RecordActions'
import Set from '@components/Set'
import { getters } from '@utils'
import { propEq } from 'rambda'

export default {
  components: {
    Record,
    RecordActions,
    Set,
  },
  props: {
    article: Object,
  },
  computed: {
    articleAuthor() {
      if (!this.article.userId) return

      return this
        .queryOne('user', this.article.userId)
          ?.lastName
    },
    siteName() {
      if (!this.article.siteId) return

      return this
        .queryOne('site', this.article.siteId)
        ?.name
    },
    status() {
      return this.articleStatuses
        .find(propEq('value', this.article.status))
    },
    ...getters('articleStatuses'),
  },
}
</script>

<style lang="scss">
</style>

<i18n>
{
  "en": {
    "author": "Author",
    "date": "Creation date",
    "site": "Site"
  }
}
</i18n>
